import { render } from "./BookCatalog.vue?vue&type=template&id=da834a60&scoped=true"
import script from "./BookCatalog.vue?vue&type=script&lang=js"
export * from "./BookCatalog.vue?vue&type=script&lang=js"

import "./BookCatalog.vue?vue&type=style&index=0&id=da834a60&scoped=true&lang=css"

import exportComponent from "D:\\code\\h5\\vue-lib\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da834a60"]])

export default __exports__